import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {ProductService} from '../../../Services/product.service';
import {ModelService} from '../../../Services/model.service';
import {Product} from '../../../Models/Product';
import {DButton, IButton} from '../../../../shared/card/card.component';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {environment} from '../../../../../environments/environment';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {Helper} from '../../../../helpers/helper.service';

const baseUri = environment.apiUrl;
const URL = baseUri + '/backoffice/product/import?file=resource.file&isStock=true';

@Component({
  selector: 'app-stock-product',
  templateUrl: './stock-product.component.html',
  styleUrls: ['./stock-product.component.scss']
})
export class StockProductComponent implements OnInit {

  public grid: Grid;
  public productId: any;
  public productName: string;
  @ViewChild('deleteModal', {static: false}) deleteModal;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('importModal', {static: false}) importModal;
  @ViewChild('uploadEl', {static: false}) uploadElRef: ElementRef;
  @ViewChild('importResultModal', {static: false}) importResultModal;
  public dropdownItemsList: any[];
  public dropdownButton: DButton;
  public params;
  public specialButtonArray;
  public specialButton: IButton[] = [];
  public isUploading: boolean;
  public uploader: FileUploader = new FileUploader({
    url: URL,
    authToken: this.auth.getBearerHeader(),
    allowedFileType: ['xlsx', 'xls', 'csv']
  });
  selectedFile: any;
  private isNotAdd = false;
  private addFileItem: boolean;
  public messages: string[] = [];
  private target: any;

  constructor(
    private translate: TranslateService,
    private broadCastService: BroadcastService,
    private router: Router,
    private productService: ProductService,
    private modelService: ModelService,
    private auth: AuthenticationService,
    private helper: Helper,
  ) {
  }

  ngOnInit() {
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
      this.uploadElRef.nativeElement.value = '';
      if (this.target) {
        this.target.value = '';
      }
    });
    this.dropdownItemsList = [
      {
        btnName: this.translate.instant('admin.order.export.dropdown_layout_stock'),
        method: 'export',
        key: Product.layout_stock
      },
    ];
    this.dropdownButton = {
      name: this.translate.instant('admin.order.export'),
      dropdownItems: [...this.dropdownItemsList]
    };

    this.specialButtonArray = [
      {name: 'Import', btnIcon: '', method: 'import', customClass: 'btn-primary'},
    ];
    this.specialButtonArray.forEach(items => {
      this.specialButton.push({
        btnIcon: items.btnIcon,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass,
      });
    });

    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.product.inventory.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          width: 180,
          minWidth: 120,
          maxWidth: 400,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.model.model',
          prop: 'models',
          type: TextColumn.type,
          width: 150,
          minWidth: 100,
          maxWidth: 300,
          translate: true,
          sortable: true,
          valueFormatter: row => {
            const items = [];
            row.forEach(item => {
              items.push(item.name);
            });
            return items.join(',');
          },
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.inventory.article_number',
          prop: 'number',
          type: TextColumn.type,
          width: 125,
          minWidth: 125,
          maxWidth: 150,
          sortable: true,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.product.inventory.free_stock',
          prop: 'stock',
          type: TextColumn.type,
          width: 106,
          minWidth: 106,
          maxWidth: 120,
          sortable: false,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.product.inventory.open_orders',
          prop: 'currentInOrder',
          type: TextColumn.type,
          width: 106,
          minWidth: 106,
          maxWidth: 120,
          sortable: false,
          translate: true,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          width: 120,
          minWidth: 120,
          maxWidth: 120,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/product/stock/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.productId = row.id;
                this.productName = row.name.bold();
                this.deleteModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.productService,
      rememberURL: this.router.url,
      method: 'getStockProduct',
      defaultSort: 'position',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          name: 'model_id',
          type: 'ng-select',
          label: 'doctrine.attributes.model',
          hasDropdownListFilter: true,
          hasNormalSearch: true,
          value: new ServiceSearchItem(this.modelService, 'getActiveModelsOfStockProducts', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            options.push({value: 'all', label: this.translate.instant('global.all')});
            for (const row of res.data) {
              options.push({value: row.id, label: row.name});
            }
            return options;
          })
        }
      ],
    };
  }

  public softDelete() {
    this.productService.softDeleteProduct(this.productId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadCastService.broadcast('refreshGrid', 'getStockProduct');
    });
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/product/stock/archive');
  }

  export(layout) {
    this.params = this.params.append('layout', layout.key);
    this.productService.exportProducts(this.params).subscribe((res: {url: string, filename: string} | boolean) => {
      if (res && typeof res === 'object') {
        const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
        el.setAttribute('href', res.url);
        el.setAttribute('download', res.filename);
        el.click();
      }
    });
  }

  import() {
    this.importModal.show();
  }

  callFunction(method: string) {
    this[method]();
  }

  setParams(event) {
    this.params = event;
  }

  cancelUpload() {
    this.uploader.clearQueue();
    this.uploadElRef.nativeElement.value = '';
    this.importModal.hide();
  }

  onFileSelected() {
    this.selectedFile = this.uploader.queue[0].file.rawFile;
  }

  uploadFile() {
    this.isUploading = true;
    this.isNotAdd = true;
    this.uploader.uploadAll();
    this.uploader.onErrorItem = (item: FileItem, response, status: number, headers: ParsedResponseHeaders) => {
      if ( status === 401) {
        return this.handle401Error();
      }
      this.isUploading = false;
      this.uploader.clearQueue();
      this.uploadElRef.nativeElement.value = '';
      const res = JSON.parse(response);
      this.helper.popMessageDialog(res.title, res.errors);
    };
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response) {
        this.addFileItem = false;
        this.isUploading = false;
        this.isNotAdd = false;
        this.importModal.hide();
        this.uploader.clearQueue();
        this.broadCastService.broadcast('refreshGrid', 'getProduct');
        this.messages = JSON.parse(response);
        this.importResultModal.show();
      }
    };
  }

  private handle401Error(): void {
    this.auth.refreshToken().subscribe((token) => {
        this.resetUploader();
        this.uploader.authToken = 'Bearer ' + token.token;
        this.uploadFile();
      }, error => {
        this.isUploading = false;
      }
    );
  }

  resetUploader() {
    this.uploader.clearQueue();
    this.uploader.addToQueue([this.selectedFile]);
  }
}
